import { FC, ReactNode } from "react";

const OLD_DOMAIN = "https://clinic.pass.curon.co";
const NEW_DOMAIN = "https://pass-clinic.curon.co";

export const RedirectNewUrl: FC<{ children: ReactNode }> = ({ children }) => {
  if (typeof window !== "undefined" && window.location.href.startsWith(OLD_DOMAIN)) {
    window.location.href = window.location.href.replace(OLD_DOMAIN, NEW_DOMAIN);
  }

  return <>{children}</>;
};
